<template>
  <div>
    <md-card :class="statusClass(quotation)">
      <md-card-header>
        <div class="md-layout md-layout md-alignment-center-space-between">
          <div>
            <h4 class="md-caption" style="font-size: 16px; padding: 4px">
              <span :class="colorIcons(quotation.status)">Cotización {{ quotation.folio }}</span>
              Proveedor {{ quotation.providerNumber }} -
              {{ quotation.providercommercialName }}
            </h4>
          </div>
          <div>
            <md-icon :class="colorIcons(quotation.status)">{{ changeIcons(quotation.status) }}</md-icon>
            <span
              class="md-body-2 text-center"
              :class="colorIcons(quotation.status)"
              v-if="quotation.status.name !== 'Activo'"
              md-direction="bottom"
            >{{ quotation.status.name }}</span>
            <span
              class="md-body-2 text-center"
              :class="colorIcons(quotation.status)"
              v-else
              md-direction="bottom"
            >No se envio correo</span>
          </div>
        </div>
        <md-divider />
        <div class="md-layout">
          <div class="md-layout-item md-gutter md-alignment-center">
            <span class="md-body-2 text-center">
              <strong>Total: {{ getTotal(quotation.materials) | money }}</strong>
            </span>
          </div>
        </div>
      </md-card-header>
      <md-table @md-selected="onSelect">
        <md-table-row :class="statusClassTable(quotation)">
          <md-table-head>Clave</md-table-head>
          <md-table-head>Requisición</md-table-head>
          <md-table-head>Nombre</md-table-head>
          <md-table-head>Requisición Siniestro</md-table-head>
          <md-table-head>Unidad</md-table-head>
          <md-table-head>Cantidad</md-table-head>
          <md-table-head>Estatus</md-table-head>
          <md-table-head>Precio</md-table-head>
          <md-table-head>Subtotal</md-table-head>
          <md-table-head v-if="quotation.totalPurchase">Seleccionar</md-table-head>
        </md-table-row>
        <template v-for="item in quotation.materials" v-show="quotation.materials.length">
          <md-table-row :class="statusClassTable(quotation)" :key="item.id">
            <md-table-cell md-label="Clave" style="padding-left: 15px">
              {{
              item.supplyCode
              }}
            </md-table-cell>
            <md-table-cell md-label="Requisición">
              {{
              item.requisitionFolio
              }}
            </md-table-cell>
            <md-table-cell md-label="Nombre">
              {{
              item.supplyName
              }}
            </md-table-cell>
            <md-table-cell md-label="Unidad">
              {{
              item.sinisterRequisition
              }}
            </md-table-cell>
            <md-table-cell md-label="Unidad">
              {{
              item.supplyUnitMeasurement
              }}
            </md-table-cell>
            <md-table-cell md-label="Cantidad">
              {{
              item.materialQuantity
              }}
            </md-table-cell>
            <md-table-cell md-label="Estatus">
              {{
              item.materialStatus
              }}
            </md-table-cell>
            <md-table-cell md-label="Precio">
              <md-field>
                <md-input
                  v-model="item.unitPrice"
                  :disabled="toResponseFile(quotation.responseFile)"
                  type="number"
                  step="any"
                  required
                ></md-input>
              </md-field>
            </md-table-cell>
            <md-table-cell
              md-label="Subtotal"
            >{{ (item.materialQuantity * item.unitPrice) | money }}</md-table-cell>
            <md-table-cell md-label="Seleccionar" v-if="quotation.totalPurchase">
              <md-checkbox class="md-fail" v-model="selected" :value="item.id"></md-checkbox>
            </md-table-cell>
          </md-table-row>
        </template>
      </md-table>
      <p
        v-if="quotation.validateField"
        style="color: red; margin: 0 10px 0 0"
        class="md-layout md-gutter md-subheading"
        :class="`md-alignment-${vertical}-${horizontal}`"
      >
        <strong>Actualice los precios*</strong>
      </p>
    </md-card>
  </div>
</template>
<script>
export default {
  props: {
    quotation: {
      type: Object,
      default: () => {},
    },
    statusClass: {
      type: Function,
      required: false,
      default: () => (item) => "",
    },
  },
  data() {
    return {
      selected: [],
      vertical: "bottom",
      horizontal: "right",
      iconStatus: "done",
    };
  },
  methods: {
    getTotal(materials) {
      return materials.reduce((sum, q) => {
        return q.materialQuantity * q.unitPrice + sum;
      }, 0);
    },
    onSelect(items) {
      this.selected = items;
    },
    toResponseFile(file) {
      if (file) {
        return true;
      } else {
        return false;
      }
    },
    changeIcons({ name }) {
      switch (name) {
        case "Rechazado":
          return "cancel";
        case "Aprobado":
          return "check_circle";
        case "Correo enviado":
          return "email";
        case "Con respuesta del proveedor":
          return "email";
        default:
          return "unsubscribe";
      }
    },
    colorIcons({ name }) {
      switch (name) {
        case "Rechazado":
          return "md-accent text-danger";
        case "Aprobado":
          return "text-success";
        case "Correo enviado":
          return "text-info";
        case "Con respuesta del proveedor":
          return "text-info";
        default:
          return "text-warning md-warning";
      }

      // }
    },
    statusClassTable({ status: { name }, providerStatus }) {
      if (name === "Activo") {
        return "activeTable";
      } else if (
        name === "Correo enviado" &&
        providerStatus.name !== "Consolidado"
      ) {
        return "newProviderTable";
      } else if (
        name === "Correo enviado" &&
        providerStatus.name === "Consolidado"
      ) {
        return "sendMailTable";
      } else if (name === "Rechazado") {
        return "rejectTable";
      }
    },
  },
  watch: {
    selected() {
      this.$emit("selected", this.selected);
    },
    quotation(nuevoValor, valorAnterior) {
      this.selected = [];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.md-card.active {
  background: md-get-palette-color(red, 100);
}
.md-table-row.activeTable {
  background: md-get-palette-color(green, 20);
}
.md-card.sendMail {
  background: md-get-palette-color(green, 100);
}
.md-table-row.sendMailTable {
  background: md-get-palette-color(green, 100);
}
.md-table-row.rejectTable {
  background: md-get-palette-color(red, 100);
}
.md-card.newProvider {
  background: md-get-palette-color(yellow, 100);
}
.md-table-row.newProviderTable {
  background: md-get-palette-color(yellow, 100);
}
.md-table-row.md-table-head.color {
  background: md-get-palette-color(red, 100);
}
.md-icon.colorIcon {
  color: md-get-palette-color(red, 100);
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuotesTracking/quotations.vue